"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _autofillBackgroundMixin = require("../autofillBackgroundMixin");
var _disabledMixin = require("../disabledMixin");
var _focusMixin = require("../focusMixin");
var _sizeMixin = require("../sizeMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var zsgCSS = function zsgCSS(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'Input.backgroundColor',
    borderColor: 'Input.borderColor',
    fontColor: 'Input.fontColor'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      fontColor = _ref.fontColor;
    return (0, _styledComponents.css)(["&[disabled]{background-color:", ";border-color:", ";color:", ";}"], backgroundColor, borderColor, fontColor);
  })(props);
};

/** @class InputMixin */
/** @method */
var InputMixin = function InputMixin(props) {
  var fluid = props.fluid;
  return (0, _styledToken.default)({
    backgroundColor: 'Input.backgroundColor',
    backgroundColorAutofill: 'Input.backgroundColorAutofill',
    backgroundColorInteractive: 'Input.backgroundColorInteractive',
    borderColor: 'Input.borderColor',
    borderColorInteractive: 'Input.borderColorInteractive',
    borderColorError: 'Input.borderColorError',
    borderRadius: 'Input.borderRadius',
    borderWidth: 'Input.borderWidth',
    focusShadow: 'Input.focus.boxShadow',
    fontColorPlaceholder: 'Input.fontColorPlaceholder',
    fontType: 'Input.fontType',
    horizontalSpacing: 'Input.horizontalSpacing',
    readOnlyPaddingLeft: 'Input.readonly.paddingLeft',
    readOnlyPaddingRight: 'Input.readonly.paddingRight',
    readOnlyBackgroundColor: 'Input.readonly.backgroundColor'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      backgroundColorAutofill = _ref2.backgroundColorAutofill,
      backgroundColorInteractive = _ref2.backgroundColorInteractive,
      borderColor = _ref2.borderColor,
      borderColorInteractive = _ref2.borderColorInteractive,
      borderColorError = _ref2.borderColorError,
      borderRadius = _ref2.borderRadius,
      borderWidth = _ref2.borderWidth,
      focusShadow = _ref2.focusShadow,
      fontColorPlaceholder = _ref2.fontColorPlaceholder,
      fontType = _ref2.fontType,
      horizontalSpacing = _ref2.horizontalSpacing,
      _ref2$readOnlyPadding = _ref2.readOnlyPaddingLeft,
      readOnlyPaddingLeft = _ref2$readOnlyPadding === void 0 ? 0 : _ref2$readOnlyPadding,
      _ref2$readOnlyPadding2 = _ref2.readOnlyPaddingRight,
      readOnlyPaddingRight = _ref2$readOnlyPadding2 === void 0 ? 0 : _ref2$readOnlyPadding2,
      _ref2$readOnlyBackgro = _ref2.readOnlyBackgroundColor,
      readOnlyBackgroundColor = _ref2$readOnlyBackgro === void 0 ? 'transparent' : _ref2$readOnlyBackgro;
    return (0, _styledComponents.css)(["appearance:none;width:", ";margin:0;padding-left:", "px;padding-right:", "px;background-color:", ";border:", "px solid;border-color:", ";border-radius:", "px;box-sizing:border-box;caret-color:", ";cursor:text;", " &::placeholder{color:", ";}&:-webkit-autofill{", "}&.edge-autofilled{background-color:", " !important;}outline:none;box-shadow:none;", " &:focus:-webkit-autofill{box-shadow:", ",0 0 0 1000px ", " inset;}&:active:not([disabled]),&:focus{background-color:", ";}&:hover:not([disabled]),&:active:not([disabled]),&:focus{border-color:", ";}", " ", " &[aria-invalid=\"true\"]{caret-color:", ";&,&[disabled],&:hover,&:active,&:focus{border-color:", ";}}&[disabled]{", "}&[readonly]{background-color:", ";padding-left:", ";padding-right:", ";&,&:hover,&:active,&:focus{border-color:", ";}}", ""], fluid ? '100%' : 'auto', horizontalSpacing, horizontalSpacing, backgroundColor, borderWidth, borderColor, borderRadius, borderColorInteractive, zsgCSS(props), fontColorPlaceholder, (0, _autofillBackgroundMixin.autofillBackgroundMixin)(props), backgroundColorAutofill, (0, _focusMixin.focusMixin)(props), focusShadow, backgroundColorAutofill, backgroundColorInteractive, borderColorInteractive, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), (0, _sizeMixin.sizeMixin)({
      fontType: fontType,
      borderWidth: borderWidth * 2
    })(props), borderColorError, borderColorError, (0, _disabledMixin.disabledMixin)(Object.assign({}, props, {
      disabled: true
    })), readOnlyBackgroundColor, readOnlyPaddingLeft, readOnlyPaddingRight, readOnlyBackgroundColor, (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.InputMixin = InputMixin;